export var SDK_VERSION = '6.12.0';
//# sourceMappingURL=version.js.map